// extracted by mini-css-extract-plugin
export var currencyInput = "_iv-1";
export var currencySymbol = "_iv-0";